import { render, staticRenderFns } from "./CohortConfig.vue?vue&type=template&id=0b63333c&scoped=true&"
import script from "./CohortConfig.vue?vue&type=script&lang=js&"
export * from "./CohortConfig.vue?vue&type=script&lang=js&"
import style0 from "./CohortConfig.vue?vue&type=style&index=0&id=0b63333c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63333c",
  null
  
)

export default component.exports